<template>
  <div class="chart-wrapper">
    <VsLoader :visible="!!chartData.isLoading" />
    <template v-if="!chartData.isLoading">
      <component
        :is="panel"
        :chartAttr="chartAttr"
        :chartData="chartData"
        :toolTipIndex="toolTipIndex"
        @tooltipIndexChanged="tooltipIndexChanged"
      />
    </template>
  </div>
</template>

<script>
import NoChartData from "./NoChartData";
import Top10Items from "./Top10Items/Index";
import ChartAndSummary from "./chartAndSummary/Index";
import { TOP10_CHART, VS_SALES, VS_AVERAGE_ORDER_VALUE } from "@/misc/desktopCharts";
import SorryMessage from "@/components/shared/SorryMessage";
import { mapGetters } from "vuex";

const STORE_ID = {
  acne: 54,
  by_melane_birger: 490,
  nudie_jeans: 133,
};

export default {
  components: {
    NoChartData,
    Top10Items,
    ChartAndSummary,
    SorryMessage,
  },
  props: {
    chartAttr: {
      type: Object,
      required: true,
    },
    chartData: {
      type: Object,
      required: true,
    },
    //
    // I dont know what should be the default value.. its possible that a null or undefined is used..
    // eslint-disable-next-line vue/require-default-prop
    toolTipIndex: {
      type: Number,
    },
  },
  computed: {
    ...mapGetters({
      currentStore: "user/getCurrentStore",
      activeFilters: "filters/getAllActiveFilters",
    }),
    itemCatOrCountryFilterActive() {
      return this.activeFilters?.itemCategories?.length > 0 || this.activeFilters?.countries?.length > 0;
    },
    isUsersPanel() {
      return this.chartAttr.name === "unique-vs-users";
    },
    checkStoreIDToHide() {
      return Object.values(STORE_ID).includes(this.currentStore.store_id);
    },
    checkChartAttrName() {
      return this.chartAttr.name === VS_SALES || this.chartAttr.name === VS_AVERAGE_ORDER_VALUE;
    },
    panel() {
      if (this.chartData.isError || (this.itemCatOrCountryFilterActive && this.isUsersPanel)) {
        return "NoChartData";
      }
      if (this.chartAttr.name === TOP10_CHART) {
        return "Top10Items";
      }
      if (this.checkStoreIDToHide && this.checkChartAttrName) {
        return "SorryMessage";
      }
      return "ChartAndSummary";
    },
  },
  methods: {
    tooltipIndexChanged(index) {
      this.$emit("tooltipIndexChanged", index);
    },
  },
};
</script>

<style scoped lang="scss">
.chart-wrapper {
  position: relative;
  height: 100%;
  border: $border-light;
  border-radius: 4px;
  background-color: white;
}
</style>
